export const ADVENTURE_CREATE = 'ADVENTURE_CREATE';
export const ADVENTURE_UPDATE = 'ADVENTURE_UPDATE';
export const ADVENTURE_IMAGE_UPLOAD = 'ADVENTURE_IMAGE_UPLOAD';
export const ADVENTURE_IMAGE_REMOVE = 'ADVENTURE_IMAGE_REMOVE';
export const ADVENTURE_FILTER_SET = 'ADVENTURE_FILTER_SET';
export const ADVENTURE_FILTER_CLEAR = 'ADVENTURE_FILTER_CLEAR';
export const ADVENTURE_ID_SET = 'ADVENTURE_ID_SET';
